import { writable } from 'svelte/store';
function createMobileCtaSubnavMenuStateStore() {
    const { subscribe, update } = writable({
        isOpen: false,
        hasNavLinks: null,
        activeContentStack: [],
    });
    function push(content) {
        update((state) => {
            state.activeContentStack.push(content);
            return state;
        });
    }
    function pop() {
        update((state) => {
            state.activeContentStack.pop();
            return state;
        });
    }
    function toggle() {
        update((state) => {
            state.isOpen = !state.isOpen;
            state.activeContentStack = [];
            return state;
        });
    }
    function setHasNavLinks(hasNavLinks) {
        update((state) => {
            state.hasNavLinks = hasNavLinks;
            return state;
        });
    }
    return {
        push,
        pop,
        subscribe,
        toggle,
        setHasNavLinks,
    };
}
export const mobileCtaSubnavMenuStateStore = createMobileCtaSubnavMenuStateStore();
